// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Hero from './components/hero';
import ProcessSection from './components/processSection';
import ScrollSection from './components/scrollSection';
import WorkSection from './components/workSection';
import ServicesSection from './components/servicesSection';
import LetsTalkSection from './components/letsTalkSection';
import Footer from './components/footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import './App.css';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <ProcessSection />
    <WorkSection />
    <ServicesSection />
    <ScrollSection />
    <LetsTalkSection />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
